import React from 'react'

type CrispCheckboxIconProps = {
  variant: 'off' | 'on' | 'mixed'
}

/**
 * Ô vuông `--kiot-check-size` (mặc định 16px), bo `--kiot-check-radius`. Viền dùng CSS border (trình duyệt snap theo pixel)
 * thay vì SVG stroke: icon nằm ở toạ độ lẻ (dòng bảng cao 55.375px…) thì stroke SVG bị nhòe, cạnh dày cạnh mỏng.
 */
export function CrispCheckboxIcon({ variant }: CrispCheckboxIconProps) {
  const on = variant !== 'off'
  return (
    <span
      aria-hidden
      style={{
        position: 'relative',
        display: 'block',
        flexShrink: 0,
        width: 'var(--kiot-check-size, 16px)',
        height: 'var(--kiot-check-size, 16px)',
        boxSizing: 'border-box',
        border: '1px solid var(--kiot-check-stroke, currentColor)',
        borderRadius: 'var(--kiot-check-radius, 2px)',
        backgroundColor: on ? 'currentColor' : '#fff',
      }}
    >
      {on ? (
        <svg
          viewBox="0 0 16 16"
          focusable="false"
          style={{
            position: 'absolute',
            top: -1,
            left: -1,
            width: 'calc(100% + 2px)',
            height: 'calc(100% + 2px)',
            display: 'block',
          }}
        >
          {variant === 'on' ? (
            <path
              d="M3.5 8 L6.5 11 L12.5 4.5"
              fill="none"
              stroke="#fff"
              strokeWidth={2}
              strokeLinecap="butt"
              strokeLinejoin="miter"
            />
          ) : (
            <rect x={3.5} y={7} width={9} height={2} fill="#fff" />
          )}
        </svg>
      ) : null}
    </span>
  )
}
